// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MenuDropdown_wrapper__bqhMe","fadeIn":"MenuDropdown_fadeIn__YUPYP","columnGrid":"MenuDropdown_columnGrid__E7Gi1","bottomLink":"MenuDropdown_bottomLink__w_0i7"};